<script setup>
  import { ref, inject, onMounted, computed } from 'vue'
  import { useRouter, useRoute } from 'vue-router'
  import Header from '@/components/Header.vue'
  import Footer from '@/components/Footer.vue'
  import DataTable from '@/components/DataTable.vue'
  import EditDialog from '@/components/EditDialog.vue'
  import { useSystemInfoStore } from '@/stores/systemInfoStore'
  import { useDialogStore } from '@/stores/dialogStore'

  const router = useRouter()
  const route = useRoute()

  const systemInfoStore = useSystemInfoStore()
  const dialogStore = useDialogStore()

  // data ///////////////////////////////////////////
  const searchText = ref('')
  const sortKey = ref('')
  const sortDesc = ref(false)
  const length = ref('')

  // 編集用データ
  const showPopupEdit = ref(false)

  // computed ///////////////////////////////////////

  // 入力ハンドラ /////////////////////////////////////////

  // UI ////////////////////////////////////////

  // methods ////////////////////////////////////////
  onMounted(async () => {
    // データ取得
    await systemInfoStore.getSystemInfo()
    systemInfoStore.initTableList()
  })

  // 会社編集ダイアログを開く
  const openEditDialog = async item => {
    await systemInfoStore.setFormData(item?.id)

    showPopupEdit.value = true
  }
</script>

<template>
  <Header />
  <main class="app-main">
    <div class="main-header">
      <h2>システムからのお知らせ</h2>

      <div class="filters">
        <!-- 検索ボックス -->
        <div class="search-box">
          <span class="material-symbols-outlined">search</span>
          <input type="search" v-model="searchText" placeholder="検索" />
        </div>

        <div class="search-result">
          {{ length }}
        </div>
      </div>
    </div>

    <div class="main-body">
      <DataTable :table-list="systemInfoStore.tableList" :data-list="systemInfoStore.systemInfos" :search-text="searchText" :sort-key="sortKey" :sort-desc="sortDesc" @select="openEditDialog" @length="length = $event"></DataTable>
    </div>
  </main>

  <!-- 編集ダイアログ -->
  <EditDialog v-model:visible="showPopupEdit" :show-save-button="false" :show-delete-button="false" :show-copy-button="false">
    <template v-slot:title>
      {{ '詳細' }}
      <span v-if="systemInfoStore.formData.isImportant" class="status-badge">
        <span class="status-text">重要</span>
      </span>
    </template>
    <template v-slot:content>
      <div class="dialog-edit">
        <dl>
          <dt>配信日</dt>
          <dd>
            <input type="date" v-model="systemInfoStore.formData.date" disabled />
          </dd>
          <dt>タイトル</dt>
          <dd>
            <input type="text" v-model="systemInfoStore.formData.title" disabled />
          </dd>
          <dt>内容</dt>
          <dd>
            <textarea v-model="systemInfoStore.formData.text" disabled></textarea>
          </dd>
        </dl>
      </div>
    </template>
  </EditDialog>
</template>

<style lang="less" scoped>
  .status-badge {
    display: inline-block;
    padding: 2px 6px;
    margin-left: 10px;
    border-radius: 4px;
    font-size: 12px !important;
    font-weight: normal !important;
    line-height: normal !important;
    background-color: #1a7247;
    color: white !important;

    .status-text {
      color: inherit !important;
      font-size: inherit !important;
      font-weight: inherit !important;
    }
  }

  .tag {
    &.application-in-progress {
      background-color: #1a7247;
      color: #ffffff;
    }

    &.unattended {
      background-color: #d3d3d3;
      color: #2f2f2f;
    }
  }
</style>
